module.exports = __webpack_public_path__ + "img/Step6.10bdb80d.png";